import { Search, X } from "lucide-react";
import { ClassMenu } from "./ClassMenu";
import { FilterPanel } from "./FilterPanel";

const Pill = ({ on, onClick, children, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`min-h-[34px] px-4 inline-flex items-center gap-1.5 rounded-full font-bold text-[14px] transition-colors ${
      on ? "bg-card text-foreground shadow-[0_1px_2px_rgba(0,0,0,.10)]" : "bg-transparent text-muted-foreground hover:text-foreground"}`}>
    {children}
  </button>
);

// Jedna lišta ovládání (§D): podzáložky · třída · Filtr · hledání.
// Seskupení Místnosti/Kategorie se přesunulo do panelu Filtr.
export function PasportToolbar({
  view, setView, qInput, setQInput,
  classes, activeClass, canEdit, canDeleteClass, onSelectClass, onAddClass, onRenameClass, onDeleteClass,
  filterOpen, setFilterOpen, filterProps,
}) {
  return (
    <div className="flex items-center gap-2.5 flex-wrap bg-secondary border border-border rounded-full px-3 py-2 mb-3"
      data-testid="pasport-toolbar">
      {/* Podzáložky */}
      <div className="inline-flex items-center gap-1 bg-muted rounded-full p-[5px]">
        <Pill on={view === "pasport"} onClick={() => setView("pasport")} testid="pasport-subtab-pasport">Položky pasportu</Pill>
        <Pill on={view === "dekory"} onClick={() => setView("dekory")} testid="pasport-subtab-dekory">Seznam dekorů</Pill>
      </div>

      {view === "pasport" && (
        <>
          <ClassMenu classes={classes} activeClass={activeClass} canEdit={canEdit} canDelete={canDeleteClass}
            onSelect={onSelectClass} onAdd={onAddClass} onRename={onRenameClass} onDelete={onDeleteClass} />

          <FilterPanel open={filterOpen} onOpenChange={setFilterOpen} {...filterProps} />

          {/* Hledání */}
          <div className="h-[38px] w-full lg:w-[250px] flex items-center gap-2 border border-border rounded-full bg-card px-3.5 ml-auto lg:ml-0">
            <Search size={15} className="text-muted-foreground shrink-0" />
            <input value={qInput} onChange={(e) => setQInput(e.target.value)} placeholder="Hledat položku i dekor"
              className="flex-1 min-w-0 bg-transparent outline-none text-[14px]" data-testid="pasport-search" />
            {qInput && (
              <button type="button" onClick={() => setQInput("")} className="text-muted-foreground hover:text-foreground shrink-0"
                data-testid="pasport-search-clear"><X size={15} /></button>
            )}
          </div>
        </>
      )}
    </div>
  );
}
